// extracted by mini-css-extract-plugin
export default {"panel":"RuleConfig_panel__R2Put","inputContainer":"RuleConfig_inputContainer__l3t5j","delimiter":"RuleConfig_delimiter__seCOr"};